module.exports = __webpack_public_path__ + "static/use-case-7-content-3-c1f1c1e870da338a6e8c212088772aa7.png";